export default {
  "iconWrapper": "_iconWrapper_1bsgu_1",
  "wrapper": "_wrapper_1bsgu_6"
};import "ni:sha-256;2pf4UwafbdGcevxzpTuxmATVOGfXbGoLDkJcYepR5vk";